export default __webpack_public_path__ + "static/media/WebLineDemo.b13abbb8.mp4";